import { convertMToMm } from './unit';

/**
 * 将场景长度（米）格式化为带 `mm` 后缀的展示文案。
 *
 * 设计说明：
 * 1. 特征定义与 Worker 求解统一使用米；
 * 2. 预览气泡、属性列表等对用户展示统一使用毫米；
 * 3. 先经 `convertMToMm` 再格式化，避免各调用方把米当毫米直接拼字符串。
 *
 * @param meters 以米为单位的长度值。
 * @returns 毫米展示文本，例如 `10mm`、`10.5mm`。
 */
export function formatLengthMmFromMeters(meters: number): string {
  // 与属性面板一致：先换算毫米，再稳定到 3 位小数，避免 0.01*1000 的浮点毛刺。
  const millimeters = Number(convertMToMm(meters).toFixed(3));
  return `${millimeters}mm`;
}
